// agent group slice
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Filter {
  name: string;
  filterByConditions: { [key: string]: string }; // Key-value pairs for conditions
}

export interface AgentGroup {
  id: string;
  name: string;
  filter_condition: Filter[];
  agent_count: number;
}

export interface AgentGroupState {
  agentGroups: AgentGroup[];
  loading: boolean;
  error: string | null;
  savedGroup: any; // Add this line to store the saved group
}

export const agentGroupInitialState: AgentGroupState = {
  agentGroups: [],
  loading: false,
  error: null,
  savedGroup: null, // Initialize savedGroup
};

const agentGroupSlice = createSlice({
  name: 'agentGroup',
  initialState: agentGroupInitialState,
  reducers: {
    fetchAgentGroup(state, action: PayloadAction<{ supervisorId: string }>) {
      state.loading = true;
      state.error = null;
    },
    fetchAgentGroupSuccess(state, action: PayloadAction<AgentGroup[]>) {
      state.loading = false;
      state.agentGroups = action.payload;
    },
    fetchAgentGroupFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    saveGroup(state, action: PayloadAction<any>) {
      // Action for saving group
      state.loading = true;
      state.error = null;
    },
    saveGroupSuccess(state, action: PayloadAction<any>) {
      // Action for successful save
      state.savedGroup = action.payload;
      state.loading = false;
    },
    saveGroupFailure(state, action: PayloadAction<string>) {
      // Action for save failure
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchAgentGroup,
  fetchAgentGroupSuccess,
  fetchAgentGroupFailure,
  saveGroup,
  saveGroupSuccess,
  saveGroupFailure,
} = agentGroupSlice.actions;

export default agentGroupSlice.reducer;
